<template>
    <div v-show="showPicDialogVisible" style="z-index: 999999;" class="look_wrap">
      <el-carousel
        height="7.80rem"
        trigger="click"
        :autoplay="false"
        arrow="always"
        class="carousel"
        ref="carouselRef"
        @change="carouselChange">
        <el-carousel-item
          v-for="(item, index) in carouselList"
          :key="index"
          style="text-align: center;">
          <div class="wrap_img">
            <img class="pic_img" :id="item[picKey]" :key="index"
                 v-if="!picLoading" :ref="item[picKey]" :src="item.href">
            <img class="empty_img" v-else
                 src="data:image/svg+xml;base64,PCEtLSBCeSBTYW0gSGVyYmVydCAoQHNoZXJiKSwgZm9yIGV2ZXJ5b25lLiBNb3JlIEAgaHR0cDovL2dvby5nbC83QUp6YkwgLS0+Cjxzdmcgd2lkdGg9IjQ0IiBoZWlnaHQ9IjQ0IiB2aWV3Qm94PSIwIDAgNDQgNDQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3Ryb2tlPSIjZmZmIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2U9IiNmZmYiPgogICAgICAgIDxjaXJjbGUgY3g9IjIyIiBjeT0iMjIiIHI9IjEiPgogICAgICAgICAgICA8YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJyIgogICAgICAgICAgICAgICAgYmVnaW49IjBzIiBkdXI9IjIuNHMiCiAgICAgICAgICAgICAgICB2YWx1ZXM9IjE7IDIwIgogICAgICAgICAgICAgICAgY2FsY01vZGU9InNwbGluZSIKICAgICAgICAgICAgICAgIGtleVRpbWVzPSIwOyAxIgogICAgICAgICAgICAgICAga2V5U3BsaW5lcz0iMC4xNjUsIDAuODQsIDAuNDQsIDEiCiAgICAgICAgICAgICAgICByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgLz4KICAgICAgICAgICAgPGFuaW1hdGUgYXR0cmlidXRlTmFtZT0ic3Ryb2tlLW9wYWNpdHkiCiAgICAgICAgICAgICAgICBiZWdpbj0iMHMiIGR1cj0iMi40cyIKICAgICAgICAgICAgICAgIHZhbHVlcz0iMTsgMCIKICAgICAgICAgICAgICAgIGNhbGNNb2RlPSJzcGxpbmUiCiAgICAgICAgICAgICAgICBrZXlUaW1lcz0iMDsgMSIKICAgICAgICAgICAgICAgIGtleVNwbGluZXM9IjAuMywgMC42MSwgMC4zNTUsIDEiCiAgICAgICAgICAgICAgICByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgLz4KICAgICAgICA8L2NpcmNsZT4KICAgICAgICA8Y2lyY2xlIGN4PSIyMiIgY3k9IjIyIiByPSIxIj4KICAgICAgICAgICAgPGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iciIKICAgICAgICAgICAgICAgIGJlZ2luPSItMS4ycyIgZHVyPSIyLjRzIgogICAgICAgICAgICAgICAgdmFsdWVzPSIxOyAyMCIKICAgICAgICAgICAgICAgIGNhbGNNb2RlPSJzcGxpbmUiCiAgICAgICAgICAgICAgICBrZXlUaW1lcz0iMDsgMSIKICAgICAgICAgICAgICAgIGtleVNwbGluZXM9IjAuMTY1LCAwLjg0LCAwLjQ0LCAxIgogICAgICAgICAgICAgICAgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIC8+CiAgICAgICAgICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9InN0cm9rZS1vcGFjaXR5IgogICAgICAgICAgICAgICAgYmVnaW49Ii0xLjJzIiBkdXI9IjIuNHMiCiAgICAgICAgICAgICAgICB2YWx1ZXM9IjE7IDAiCiAgICAgICAgICAgICAgICBjYWxjTW9kZT0ic3BsaW5lIgogICAgICAgICAgICAgICAga2V5VGltZXM9IjA7IDEiCiAgICAgICAgICAgICAgICBrZXlTcGxpbmVzPSIwLjMsIDAuNjEsIDAuMzU1LCAxIgogICAgICAgICAgICAgICAgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIC8+CiAgICAgICAgPC9jaXJjbGU+CiAgICA8L2c+Cjwvc3ZnPg==" alt="">
            <!--<img v-else src="./img/loading.gif" alt="">-->
          </div>
          <p class="c-white fz20 mt20 wrap_p">{{showPicDialogTitle}}</p>
        </el-carousel-item>
      </el-carousel>
      <svg @mousemove="svgColor = true" @mouseleave="svgColor = false"
           @click="showPicDialogVisible = false"
           class="icon close curp" aria-hidden="true">
        <use v-if="!svgColor" xlink:href="#icon-guanbi_fanbai"></use>
        <use v-else="!svgColor" xlink:href="#icon-guanbi_xuantingdianji"></use>
      </svg>
      <div :style="language=== 'en_US' ? 'width: 10rem' : ''" class="bottom_options flex-y-c">
        <div :style="language=== 'en_US' ? 'width: 1.1rem' : ''" @click="imgChange('1')" class="options_item fd_item">
          <div class="fd_img options_item_img"></div>
          <p class="c-white mt4">{{$t('common.common.fd')}}</p>
        </div>
        <div :style="language=== 'en_US' ? 'width: 1.1rem' : ''" @click="imgChange('0')" class="options_item sx_item">
          <div class="sx_img options_item_img"></div>
          <p class="c-white mt4">{{$t('common.common.sx')}}</p>
        </div>
        <div :style="language=== 'en_US' ? 'width: 1.1rem' : ''" @click="imgChange('2')" class="options_item sxfz_item">
          <div class="sxfz_img options_item_img"></div>
          <p class="c-white mt4">{{$t('common.common.sxfz')}}</p>
        </div>
        <div :style="language=== 'en_US' ? 'width: 1.1rem' : ''" @click="imgChange('3')" class="options_item fz_item">
          <div class="fz_img options_item_img"></div>
          <p class="c-white mt4">{{$t('common.common.zyfz')}}</p>
        </div>
        <div :style="language=== 'en_US' ? 'width: 1.1rem' : ''" @click="imgChange('5')" class="options_item zz_item">
          <div class="zz_img options_item_img"></div>
          <p class="c-white mt4">{{$t('common.common.zz')}}</p>
        </div>
        <div :style="language=== 'en_US' ? 'width: 1.1rem' : ''" @click="imgChange('6')" class="options_item yz_item">
          <div class="yz_img options_item_img"></div>
          <p class="c-white mt4">{{$t('common.common.yz')}}</p>
        </div>
        <div :style="language=== 'en_US' ? 'width: 1.1rem' : ''" @click="imgChange('4')" class="options_item xz_item">
          <div class="xz_img options_item_img"></div>
          <p class="c-white mt4">{{$t('common.common.xz')}}</p>
        </div>
      </div>
    </div>
</template>

<script>
  import {
    extend,
    get,
    find,
    each,
    filter,
    map
  } from "lodash"
  import {
    mapGetters,
    mapActions,
    mapState
  } from 'vuex';
  import {downImage} from 'common/js/util';
  import {toHtml2canvas, putb64} from 'common/js/util';
  import {modifyPicture} from 'common/api/public';

  export default {
    data() {
      return {
        showPicDialogVisible: false,
        showPicDialogTitle: '',
        svgColor: false,

        picNum: 1,
        rotateNumX: 0,
        rotateNumY: 0,
        rotateNum: 0,
        carouselFiled: '',
        picLoading: false,

        preventDefault: false,
      };
    },
    props:{
      carouselList: { // item 必须要有 name key选传
        type: Array,
        default: []
      },
      picKey:{
        type: String,
        default: 'key'
      },
      uploadToken: {
        type: String,
        default: undefined
      },
      curePlanId:{
        type: String || Number,
        default: undefined
      },
      canChange:{
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapGetters({}),
      ...mapState({
        language: state => state.language,
      }),
    },

    methods: {
      ...mapActions({}),

      imgChange(type) {
        if(this.picLoading) return;
        // 0 缩小   1 放大   2 左转   3 右转
        const filedRef = this.$refs[this.carouselFiled][0];
        if(filedRef) {
          switch (type) {
            case '0':
              if(this.picNum > 0.5) {
                this.picNum -= 0.1;
              }
              break;
            case '1':
              if(this.picNum < 1.5) {
                this.picNum += 0.1;
              }
              break;
            case '2':
              this.rotateNumX += 180;
              break;
            case '3':
              this.rotateNumY += 180;
              break;
            case '5':
              this.rotateNum -= 90;
              break;
            case '6':
              this.rotateNum += 90;
              break;
            case '4':
              let img = get(find(this.carouselList, item => item[this.picKey] === this.carouselFiled), 'href');
              setTimeout(() => {
                downImage(img, this.showPicDialogTitle);
              }, 100);
              break;
          }
          if(type !== '4') {
            this.picLoading = true;
            filedRef.style.transform = `scale(${this.picNum}) rotateX(${this.rotateNumX}deg) rotateY(${this.rotateNumY}deg) rotateZ(${this.rotateNum}deg)`;
            if([2,3,5,6].includes(+type) && this.canChange){
              toHtml2canvas(filedRef).then(picBase64 => {
                this.picNum = 1;
                this.rotateNumX = 0;
                this.rotateNumY = 0;
                this.rotateNum = 0;
                filedRef.style.transform = `scale(${this.picNum}) rotateX(${this.rotateNumX}deg) rotateY(${this.rotateNumY}deg) rotateZ(${this.rotateNum}deg)`;
                putb64(picBase64, this.uploadToken).then(res => {
                  const {hash} = res;
                  const config = {
                    otherPicture: []
                  };
                  this.$emit('changeCarouselList', {hash, Filed: this.carouselFiled});
                  this.carouselList.forEach(item => {

                    if(item[this.picKey] === this.carouselFiled) {
                      if(item.filed === 'otherPicture'){
                        config.otherPicture.push(hash);
                      }else{
                        config[item.filed] = hash;
                      }
                      return {
                        ...item,
                        href: hash
                      };
                    }
                    if(item.filed === 'otherPicture'){
                      config.otherPicture.push(item.href);
                    }else{
                      config[item.filed] = item.href;
                    }
                    return item;
                  });
                  let data = {};
                  for (let i in config){
                    if(i !== 'otherPicture'){
                      let itemList = config[i].split('/');
                      data[i] = itemList[itemList.length - 1];
                    }
                  }
                  if(config.otherPicture){
                    data.otherPicture = map(config.otherPicture, it => {
                      if(it.substr(0,4) === 'http'){
                        let itemList = it.split('/');
                        return itemList[itemList.length - 1];
                      }
                      return it;
                    }).join(',')
                  }
                  modifyPicture({
                    ...data,
                    id: this.curePlanId
                  }).then(() => {
                    this.changePicLoading();
                  });
                });
              });
            }else {
              this.picLoading = false;
            }
          }
        }
      },
      changePicLoading(){
        this.picLoading = false;
        this.$forceUpdate();
      },
      async setActiveItem(i,name) {
        this.carouselFiled = i + '';
        this.$forceUpdate();
        this.showPicDialogVisible = true;
        this.preventDefault = false;
        await this.$nextTick();
        this.$refs.carouselRef && this.$refs.carouselRef.setActiveItem(i);
        this.showPicDialogTitle = name;
      },
      setPreventDefault(){
        this.preventDefault = true;
      },
      carouselChange(index) {
        if(this.preventDefault || !this.showPicDialogVisible) return;
        this.setActiveItem(index,this.carouselList[index].name);
        this.carouselFiled = this.carouselList[index][this.picKey] + '';
        this.picNum = 1;
        this.rotateNumX = 0;
        this.rotateNumY = 0;
        this.rotateNum = 0;
      },
      showPicFn(name,key){
        this.$forceUpdate();
        each(this.carouselList,(item,index) =>{
          if(item[this.picKey] === key){
            this.setActiveItem(index,name);
          }
        });
      },
    },
    created() {
    }
  }
</script>

<style lang="scss" scoped>
  .look_wrap{
    width: 100vw;
    height: 100vh;
    background: rgba(46, 47, 48, 0.9);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999999;
    .carousel{
      position: relative;
      top: 60px;
      .wrap_img{
        height: 80%;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        .pic_img{
          height: 100%;
        }
        .empty_img{
          display: block;
          width: 200px;
          height: 200px;
        }
      }
      .wrap_p{
        position: absolute;
        bottom: 110px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    .close{
      width: 24px;
      height: 24px;
      position: absolute;
      right: 40px;
      top: 40px;
    }
  }
  .bottom_options{
    position: absolute;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);
    width: 608px;
    justify-content: space-between;
    z-index: 99999;
    .options_item{
      width: 80px;
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      cursor: pointer;
      text-align: center;
      .options_item_img{
        width: 24px;
        height: 24px;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        /*transition: all 0.1s;*/
      }
      .fd_img{
        background-image: url('./img/fd.png');
      }
      .sx_img{
        background-image: url('./img/sx.png');
      }
      .sxfz_img{
        background-image: url('./img/sxfz.png');
      }
      .fz_img{
        background-image: url('./img/fz.png');
      }
      .zz_img{
        background-image: url('./img/zz.png');
      }
      .yz_img{
        background-image: url('./img/yz.png');
      }
      .xz_img{
        background-image: url('./img/xz.png');
      }
    }
    .fd_item:hover .fd_img{
      background-image: url('./img/fd_y.png');
    }
    .sx_item:hover .sx_img{
      background-image: url('./img/sx_y.png');
    }
    .sxfz_item:hover .sxfz_img{
      background-image: url('./img/sxfz_y.png');
    }
    .fz_item:hover .fz_img{
      background-image: url('./img/fz_y.png');
    }
    .zz_item:hover .zz_img{
      background-image: url('./img/zz_y.png');
    }
    .yz_item:hover .yz_img{
      background-image: url('./img/yz_y.png');
    }
    .xz_item:hover .xz_img{
      background-image: url('./img/xz_y.png');
    }
  }

  /deep/ .el-carousel__container{
  }
  /deep/ .el-carousel__indicators{
    left: 50%;
    bottom: 80px !important;
  }
  /deep/ .el-carousel__button{
    width: 0.08rem !important;
    height: 0.08rem !important;
  }
  /deep/ .is-active .el-carousel__button{
    width: 20px !important;
    height: 8px !important;
    border-radius: 5px !important;
  }
  /deep/ .el-carousel__arrow{
    width: 64px !important;
    height: 64px !important;
  }
  /deep/ .el-carousel__arrow:hover{
    background-color: #4B4D4E;
  }
  /deep/ .el-carousel__arrow i{
    font-size: 32px;
  }
  /deep/ .el-carousel__item{
    opacity: 0 !important;
    transition: opacity 0.5s !important;
    /*padding: 0 2rem;*/
  }
  /deep/ .el-carousel__item.is-animating{
    transition: none !important;
    opacity: 1 !important;
    transition: opacity 0.5s !important;
  }
</style>